import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ViewList, ViewModule } from '@mui/icons-material';

const ListViewToggle = ({ isCardView, handleViewChange }) => {
  return (
    <ToggleButtonGroup size="small" value={isCardView ? 'card' : 'list'} exclusive onChange={handleViewChange}>
      <ToggleButton value="list" aria-label="list">
        <ViewList />
      </ToggleButton>
      <ToggleButton value="card" aria-label="card">
        <ViewModule />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ListViewToggle;
